var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48575 4.48575 0 10 0C15.5142 0 20 4.48575 20 10C20 15.5142 15.5142 20 10 20C4.48575 20 0 15.5142 0 10ZM10 18.6372C5.23797 18.6372 1.36281 14.762 1.36281 10C1.36281 5.23797 5.23797 1.36281 10 1.36281C14.7628 1.36281 18.6372 5.23798 18.6372 10C18.6372 14.762 14.762 18.6372 10 18.6372Z",
    fill: "#571BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6814 5.36804C10.6814 4.99114 10.3769 4.68662 10 4.68662C9.62312 4.68662 9.3186 4.99114 9.3186 5.36804V10.0626C9.3186 10.2774 9.41955 10.4797 9.59096 10.6076L12.7208 12.955C12.8436 13.047 12.9865 13.0913 13.1289 13.0913C13.3373 13.0913 13.5412 12.9978 13.6745 12.8183C13.9006 12.518 13.8398 12.0902 13.5386 11.8646L10.6814 9.72182V5.36804Z",
    fill: "#571BCE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHours);
export default __webpack_public_path__ + "static/media/hours.ca47f52b193be770785c2c9b4dda0f90.svg";
export { ForwardRef as ReactComponent };